import { render, staticRenderFns } from "./CenterDialogs.vue?vue&type=template&id=f6a9d186&"
import script from "./CenterDialogs.vue?vue&type=script&lang=js&"
export * from "./CenterDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports